import { render } from "./good_info.vue?vue&type=template&id=565e9f8f"
import script from "./good_info.vue?vue&type=script&lang=js"
export * from "./good_info.vue?vue&type=script&lang=js"

import "./good_info.vue?vue&type=style&index=0&id=565e9f8f&lang=css"

import exportComponent from "E:\\zhaojiaming\\smz2023\\fashengren\\speaker_h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__